(() => {
  // A section can include this asset again when added in the theme editor.
  if (window.bwDeferredVideoInitialized) return;
  window.bwDeferredVideoInitialized = true;

  const selector = 'video[data-bw-deferred-video]';
  const pending = new Set();

  function activate(video) {
    if (!pending.delete(video)) return;
    if (observer) observer.unobserve(video);
    if (!video.isConnected) return;

    const sources = Array.from(video.querySelectorAll('source[data-src]'));
    const usable = sources.filter((source) => source.dataset.src.trim());
    if (!usable.length) return;

    usable.forEach((source) => {
      source.src = source.dataset.src.trim();
      source.removeAttribute('data-src');
    });
    video.load();
    // Preserve muted inline autoplay; do not force playback past browser policy.
    const playback = video.play();
    if (playback && typeof playback.catch === 'function') playback.catch(() => {});
  }

  const observer = 'IntersectionObserver' in window
    ? new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) activate(entry.target);
      });
    }, { rootMargin: '1200px 0px', threshold: 0 })
    : null;

  function initialize(root) {
    root.querySelectorAll(selector).forEach((video) => {
      if (pending.has(video) || !video.querySelector('source[data-src]')) return;
      pending.add(video);
      if (observer) observer.observe(video);
      else activate(video);
    });
  }

  initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll(selector).forEach((video) => {
      if (pending.delete(video) && observer) observer.unobserve(video);
    });
  });
})();
